import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const missingSipApi = createAsyncThunk(
  "missingSip",
  async ({ name = "", startDate = "", endDate = "" }) => {
    const params = {};
    if (name) {
      params.name = name;
    }
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }
    const response = await axiosInstance.get("/report/sipMissing", {
      params, 
    });
    if (response) {
      return response.data;
    }
  }
);

const missingSipSlice = createSlice({
  name: "missingSip",
  initialState: {
    missingSip: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(missingSipApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(missingSipApi.fulfilled, (state, action) => {
        state.missingSip = action.payload;
        state.loading = false;
      })
      .addCase(missingSipApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default missingSipSlice.reducer;

